import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import { deleteShipment } from '#action/shipment/overview';
import propTypes from './prop-types';
import { DeleteTitle, DialogTitle, StyledDialogContentText } from './styles';

class DeleteDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputFieldError: false
    };
  }

  handleClose = () => {
    this.props.setShowDialog(false);
    this.setState({ inputFieldError: false });
  };

  handleOk = async () => {
    const { shipment, dispatch, history, onDelete } = this.props;
    if (this.inputElement.value === (shipment.label ?? '')) {
      this.props.setShowDialog(false);
      await dispatch(deleteShipment(shipment.id));
      history.push('/shipment');
      if (onDelete) {
        onDelete();
      }
    } else {
      this.setState({ inputFieldError: true });
    }
  };

  render() {
    const { shipment, showDialog } = this.props;

    return (
      <Dialog
        open={showDialog}
        onClose={this.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <DeleteTitle>
            Do you want to delete the &quot;
            {shipment.label}
            &quot; shipment?
          </DeleteTitle>
        </DialogTitle>
        <DialogContent>
          <StyledDialogContentText id="alert-dialog-description">
            Type the shipment name to confirm
          </StyledDialogContentText>
          <TextField
            label="Shipment name"
            fullWidth
            margin="normal"
            variant="outlined"
            inputRef={el => (this.inputElement = el)}
            error={this.state.inputFieldError}
            helperText={this.state.inputFieldError ? 'Invalid name' : ''}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose} variant="outlined" color="primary">
            Cancel
          </Button>
          <Button onClick={this.handleOk} variant="outlined" color="primary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

DeleteDialog.propTypes = propTypes;

export default DeleteDialog;
